$(function () {
  const $btn = $('.sysFormField').find('button[name="searchAddress"]');
  const $newBtn = $btn.addClass('sysButton');
  if ($btn.length >= 1) {
    $btn.each(function () {
      $(this).parent('div').after($newBtn);
      //$(this).remove();
    });
  }
});
